module.exports = __webpack_public_path__ + "img/Minnesota outline.a76c52bc.png";